import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  SideNavigation,
  SideNavigationItem,
} from '../../components/SideNavigation';

export const AdminMenu = React.memo(() => (
  <SideNavigation>
    <SideNavigationItem isDefault to="users">
      <FormattedMessage id="admin.menu.users" defaultMessage="Users" />
    </SideNavigationItem>
    <SideNavigationItem to="imports">
      <FormattedMessage id="admin.menu.imports" defaultMessage="Imports" />
    </SideNavigationItem>
    <SideNavigationItem to="activity">
      <FormattedMessage
        id="admin.menu.activity"
        defaultMessage="Activity log"
      />
    </SideNavigationItem>
    <SideNavigationItem to="content-reports">
      <FormattedMessage
        id="admin.menu.contentReports"
        defaultMessage="Content reports"
      />
    </SideNavigationItem>
  </SideNavigation>
));
